import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InstitutionProfileForm from '_forms/institutionProfileForm';
import useCanAdminLicenses from '../../../hooks/useCanAdminLicenses';

const InstitutionProfile = ({ profile, onProfileSubmit }) => {
  const canAdmin = useCanAdminLicenses();

  const [state, setState] = useState({ profile, dirty: false });

  const onChange = (_, data) => {
    setState({
      profile: Object.assign({}, state.profile, { [data.name]: data.value }),
      dirty: true
    });
  };

  const onAdminChange = (selections) => {
    setState({
      profile: Object.assign({}, state.profile, { administrators: selections }),
      dirty: true
    });
  };

  const onCancel = (e) => {
    e.preventDefault();
    setState({ profile, dirty: false });
  }

  const onSubmit = (e) => {
    e.preventDefault();
    onProfileSubmit(state.profile);
    setState({ profile: state.profile, dirty: false });
  }

  return (
    <InstitutionProfileForm
      profile={state.profile}
      dirty={state.dirty}
      onSubmit={onSubmit}
      onAdminChange={onAdminChange}
      onChange={onChange}
      onCancel={onCancel}
      readOnly={!canAdmin}
    />
  );
};

InstitutionProfile.propTypes = {
  onProfileSubmit: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired
};

export default InstitutionProfile;



// WEBPACK FOOTER //
// ./webAdmin/components/institutions/institution/profile.js